/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  UserListingRoleAssignment,
  UserListingRoleAssignmentFromJSON,
  UserListingRoleAssignmentToJSON,
} from './'

/**
 *
 * @export
 * @interface UserAccountListing
 */
export interface UserAccountListing {
  /**
   * The userKey assigned by the system when the user was first created.
   * @type number
   * @memberof UserAccountListing
   */
  userKey: number
  /**
   * The personal email the user registered with.
   * @type string
   * @memberof UserAccountListing
   */
  username: string
  /**
   * An official, CC-assigned and -managed email address. This cannot be set or changed by most users.
   * @type string
   * @memberof UserAccountListing
   */
  email?: string
  /**
   * The first name of the user.
   * @type string
   * @memberof UserAccountListing
   */
  firstName?: string
  /**
   * The last name of the user.
   * @type string
   * @memberof UserAccountListing
   */
  lastName?: string
  /**
   * If true, the user account cannot be logged into. If false, the user account is active and can be logged into. Defaults to false.
   * @type boolean
   * @memberof UserAccountListing
   */
  isDeactivated?: boolean
  /**
   * Indicates whether the user has paid their membership fee and is currently enrolled.
   * @type boolean
   * @memberof UserAccountListing
   */
  isMember?: boolean
  /**
   * The active roles that this user account currently has.
   * @type {Array<UserListingRoleAssignment>}
   * @memberof UserAccountListing
   */
  roles: Array<UserListingRoleAssignment>
  /**
   * The user’s country of residence
   * @type string
   * @memberof UserAccountListing
   */
  countryOfResidence?: string
  /**
   * The user’s country of citizenship
   * @type string
   * @memberof UserAccountListing
   */
  countryOfCitizenship?: string
}

export function UserAccountListingFromJSON(json: any): UserAccountListing {
  return UserAccountListingFromJSONTyped(json, false)
}

export function UserAccountListingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserAccountListing {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userKey: json['userKey'],
    username: json['username'],
    email: !exists(json, 'email') ? undefined : json['email'],
    firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
    lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
    isDeactivated: !exists(json, 'isDeactivated')
      ? undefined
      : json['isDeactivated'],
    isMember: !exists(json, 'isMember') ? undefined : json['isMember'],
    roles: (json['roles'] as Array<any>).map(UserListingRoleAssignmentFromJSON),
    countryOfResidence: !exists(json, 'countryOfResidence')
      ? undefined
      : json['countryOfResidence'],
    countryOfCitizenship: !exists(json, 'countryOfCitizenship')
      ? undefined
      : json['countryOfCitizenship'],
  }
}

export function UserAccountListingToJSON(
  value?: UserAccountListing | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userKey: value.userKey,
    username: value.username,
    email: value.email,
    firstName: value.firstName,
    lastName: value.lastName,
    isDeactivated: value.isDeactivated,
    isMember: value.isMember,
    roles: (value.roles as Array<any>).map(UserListingRoleAssignmentToJSON),
    countryOfResidence: value.countryOfResidence,
    countryOfCitizenship: value.countryOfCitizenship,
  }
}
